'use client';

import React__default, { useState, useRef, useCallback, useEffect } from 'react';
import SlideModal from '../Modal/SlideModal.js';
import '../_virtual/_tslib.js';
import useFloating from '../hooks/useFloating/index.js';
import useClickAway from '../hooks/useClickAway.js';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import { Container, TooltipContent } from './SimpleTooltip.css.js';
import Tooltip from './Tooltip.js';

var TIMEOUT = 10;
var SimpleTooltip = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b, _c = _a.gap, gap = _c === void 0 ? 5 : _c, content = _a.content, referenceElement = _a.referenceElement, isMobile = _a.isMobile, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.title, title = _e === void 0 ? null : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.isOriginal, isOriginal = _g === void 0 ? false : _g, _h = _a.tooltipClassName, tooltipClassName = _h === void 0 ? '' : _h, custom = _a.custom, _j = _a.position, position = _j === void 0 ? 'absolute' : _j, _k = _a.isShifting, isShifting = _k === void 0 ? false : _k, _l = _a.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _l === void 0 ? false : _l, _m = _a.enablePortal, enablePortal = _m === void 0 ? false : _m;
    var _o = useState(null), mouseOverElement = _o[0], setElementMouseOver = _o[1];
    var _p = useState('enter'), mouseState = _p[0], setMouseState = _p[1];
    var leaveTimeout = useRef(null);
    var _q = useState(false), isVisible = _q[0], setElementVisible = _q[1];
    var _r = useFloating({
        placement: placement,
        position: position,
        config: {
            offset: gap,
            isShift: isShifting,
            useWindowAsFlippingContainer: useWindowAsFlippingContainer
        }
    }), refs = _r.refs, context = _r.context, FloatingPortal = _r.FloatingPortal;
    useClickAway(function () {
        setElementVisible(false);
    }, {
        nodeRefs: [refs.popup, refs.reference]
    });
    var handleMouseEnter = useCallback(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (isMobile) {
            return;
        }
        setElementVisible(true);
        setElementMouseOver(e.target);
    }, [disabled]);
    var handleMouseLeave = useCallback(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setMouseState('leave');
        setElementMouseOver(null);
    }, [disabled]);
    var handleMouseEnterTooltip = useCallback(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        setElementMouseOver(e.target);
    }, [disabled]);
    var handleMouseClick = useCallback(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (!isMobile) {
            return;
        }
        setElementVisible(function (prevState) { return !prevState; });
    }, [disabled]);
    var handleMouseLeaveTooltip = useCallback(function (e) {
        e.stopPropagation();
        if (disabled) {
            return;
        }
        if (isMobile) {
            return;
        }
        if (leaveTimeout && leaveTimeout.current)
            clearTimeout(leaveTimeout.current);
        leaveTimeout.current = setTimeout(function () {
            setElementVisible(false);
        }, TIMEOUT);
        setElementMouseOver(null);
    }, [disabled, isMobile]);
    useEffect(function () {
        if (isMobile) {
            return;
        }
        if (leaveTimeout && leaveTimeout.current)
            clearTimeout(leaveTimeout.current);
        leaveTimeout.current = setTimeout(function () {
            if (mouseState === 'leave' && !mouseOverElement) {
                setElementVisible(false);
                setMouseState('enter');
            }
        }, TIMEOUT);
    }, [mouseState, mouseOverElement, isMobile]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container, { ref: refs.setReference, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleMouseClick, className: className }, referenceElement),
        isMobile && !isOriginal ? (React__default.createElement(SlideModal, { isOpen: isVisible, title: title, onBack: function () {
                setElementVisible(false);
            }, titleStyle: {
                flex: '1',
                textAlign: 'center',
                height: 20
            } },
            React__default.createElement(TooltipContent, null, content))) : (React__default.createElement(FloatingPortal, { enable: enablePortal },
            React__default.createElement(Tooltip, { show: isVisible, onMouseEnter: handleMouseEnterTooltip, onMouseLeave: handleMouseLeaveTooltip, content: content, style: {
                    position: context.position,
                    top: context.y,
                    left: context.x,
                    zIndex: 9999
                }, className: tooltipClassName, ref: refs.setPopup, offsetHeight: gap, custom: custom })))));
};

export { SimpleTooltip as default };
//# sourceMappingURL=index.js.map
